// Direction B "Ink Header" typing indicator.
// Shape mirrors an agent bubble (muted-100 bg, top-left corner clipped, 14px
// radius). Three 5×5 muted-400 dots, 4px gap, 1.3s ease-in-out infinite with
// 0/180/360ms stagger.
//
// Two variants:
//   - block:  full bubble look — used during the TTFT gap (first-token wait)
//             between user submit and agent's first character.
//   - inline: dot row only, no bubble — used inside an in-flight AssistantTurn
//             between tool calls so the typing cue sits next to the tool's
//             intermediate output.

export interface TypingDotsProps {
  variant?: 'inline' | 'block'
}

export function TypingDots({ variant = 'block' }: TypingDotsProps) {
  if (variant === 'inline') {
    return (
      <div
        data-testid="typing-dots"
        data-variant="inline"
        className="inline-flex items-center gap-1 py-1"
        aria-label="Agent is typing"
      >
        <Dot />
        <Dot delay="180ms" />
        <Dot delay="360ms" />
      </div>
    )
  }
  return (
    <div data-testid="typing-dots" data-variant="block" className="self-start animate-bubbleIn">
      <div
        className="bg-muted-100 px-[14px] py-[11px] rounded-2xl rounded-tl-[4px] inline-flex items-center gap-1"
        aria-label="Agent is typing"
      >
        <Dot />
        <Dot delay="180ms" />
        <Dot delay="360ms" />
      </div>
    </div>
  )
}

function Dot({ delay = '0ms' }: { delay?: string }) {
  return (
    <span
      className="w-[5px] h-[5px] rounded-full bg-muted-400 animate-dotPulse"
      style={{ animationDelay: delay }}
    />
  )
}
